import { addError } from 'actions'
import OT from '@opentok/client'
import NetworkTest, { ErrorNames } from 'opentok-network-test-js'
import {
  startArchiving,
  toggleRecordingState,
} from 'actions/opentok'
import videoServices from 'services/video'
import { updateState } from 'interview/actions/candidate'
import config from 'config'

export const NETWORK_TEST_START = 'NETWORK_TEST_START'
export const QUALITY_TEST_START = 'QUALITY_TEST_START'
export const NETWORK_TEST_DATA_UPDATE = 'opentok/network-test/result'
export const QUALITY_TEST_DATA_UPDATE = 'opentok/quality-test/result'
export const INTERVIEW_STATE_UPDATE = 'INTERVIEW_STATE_UPDATE'
export const ERROR_UPDATE = 'ERROR_UPDATE'

const automaticArchiving = !config.DISABLE_SEQUENCED_INTERVIEW_AUTOMATIC_ARCHIVING
let otNetworkTest
let countdown

export const startNetworkTest = () => ({ type: NETWORK_TEST_START })

export const startQualityTest = () => ({ type: QUALITY_TEST_START })

export const updateNetworkTestData = payload => ({ type: NETWORK_TEST_DATA_UPDATE, payload })

export const updateQualityTestData = payload => ({ type: QUALITY_TEST_DATA_UPDATE, payload })

export const updateError = payload => ({ type: ERROR_UPDATE, payload })

export const updateInterviewState = payload => ({ type: INTERVIEW_STATE_UPDATE, payload })

export const setError = error => (dispatch) => {
  switch (error.name) {
    case ErrorNames.CONNECTIVITY_ERROR:
    case ErrorNames.CONNECT_TO_SESSION_ERROR:
      dispatch(updateError('generalError'))
      break
    case ErrorNames.UNSUPPORTED_BROWSER:
    case 'OT_NOT_SUPPORTED':
      dispatch(updateError('unsupportedBrowser'))
      break
    case 'OT_CONNECT_FAILED':
    case 'OT_NOT_CONNECTED':
    case ErrorNames.CONNECT_TO_SESSION_NETWORK_ERROR:
      dispatch(updateError('networkError'))
      break
    case ErrorNames.FAILED_TO_OBTAIN_MEDIA_DEVICES:
    case 'OT_USER_MEDIA_ACCESS_DENIED':
    case 'OT_NO_VALID_CONSTRAINTS':
      dispatch(updateError('allowMediaDevicesError'))
      break
    case ErrorNames.NO_AUDIO_CAPTURE_DEVICES:
    case ErrorNames.NO_VIDEO_CAPTURE_DEVICES:
    case 'OT_NO_DEVICES_FOUND':
    case 'OT_HARDWARE_UNAVALABLE':
      dispatch(updateError('noAvailableDevicesError'))
      break
    case ErrorNames.INIT_PUBLISHER_ERROR:
    case ErrorNames.FAILED_TO_CREATE_LOCAL_PUBLISHER:
      dispatch(updateError('initPublisherError'))
      break
    case ErrorNames.MISSING_OPENTOK_INSTANCE:
      dispatch(addError(error))
      dispatch(updateError('generalError'))
      break
    case ErrorNames.INCOMPLETE_SESSON_CREDENTIALS:
    case ErrorNames.MISSING_SESSON_CREDENTIALS:
    case ErrorNames.INVALID_SESSON_CREDENTIALS:
      dispatch(addError(error))
      dispatch(updateError('generalError'))
      break
    default:
      dispatch(addError(error))
      dispatch(updateError('generalError'))
  }
}

export const startTest = (data, uuid) => (dispatch, getState, { emit }) => {
  otNetworkTest = otNetworkTest || new NetworkTest(OT, data)
  dispatch(updateError(''))
  dispatch(startNetworkTest())
  otNetworkTest.testConnectivity()
    .then((results) => {
      emit(updateNetworkTestData({ uuid, results }))
      if (results.success) {
        dispatch(startQualityTest())
        otNetworkTest.testQuality()
          .then((results) => {
            emit(updateQualityTestData({ uuid, results }))
          })
          .catch((err) => {
            dispatch(setError(err))
            dispatch(updateQualityTestData())
            otNetworkTest.stop()
          })
      }
    })
    .catch((err) => {
      dispatch(updateNetworkTestData())
      dispatch(setError(err))
      otNetworkTest.stop()
    })
}

export const setCountdown = (answerCountdown, newState) => (dispatch, getState) => {
  const { uuid } = getState().candidate
  const { jobOpening: { questions }, candidate } = getState().interview
  const { interviewState: { index } } = getState().interview.sequencedInterview
  const countdownState = answerCountdown
    ? { answerCountdown: true, onAnswer: true }
    : { toNextCountdown: true }

  dispatch(updateInterviewState({ ...countdownState, stopped: false, timerCount: 0 }))
  countdown = setTimeout(() => {
    if (answerCountdown) {
      dispatch(updateInterviewState({ ...newState, loading: true, timerCount: 0, answerCountdown: false }))
      dispatch(startArchiving({ uuid }))
      if (!automaticArchiving) {
        dispatch(toggleRecordingState(true))
      }
    } else if (candidate.state.includes('finished')) {
      const nextQuestion = questions[index + 1]
      dispatch(updateState(uuid, nextQuestion._id, answerCountdown))
      dispatch(updateInterviewState(newState))
    }
  }, 10000)
}

export const clearCountdown = () => () => {
  if (countdown) {
    clearTimeout(countdown)
  }
}

export const toNextQuestion = (questionNumber, shouldMoveToNextQuestion) => (dispatch, getState) => {
  const { jobOpening } = getState().interview
  const { uuid } = getState().candidate
  const nextQuestion = jobOpening.questions[questionNumber]
  const stopped = !nextQuestion
  dispatch(updateInterviewState({ stopped }))
  const newInterviewState = {
    index: questionNumber,
    onAnswer: false,
    questionView: true,
    timerCount: 0,
    takeCount: 1,
    stopped,
    currentQuestion: nextQuestion,
  }

  if (!nextQuestion) {
    dispatch(updateInterviewState({ timerCount: 0, currentQuestion: undefined }))
    dispatch(updateState(uuid))
  } else if (shouldMoveToNextQuestion) {
    dispatch(updateState(uuid, nextQuestion._id))
    dispatch(updateInterviewState(newInterviewState))
  } else {
    dispatch(setCountdown(false, { ...newInterviewState, toNextCountdown: false }))
  }
}

export const uploadSnapshot = () => (dispatch, getState) => {
  const { publisher, archive } = getState().global.opentok
  if (publisher && archive) {
    const imgData = publisher.getImgData()
    const snapshotUrl = `data:image/png;base64,${imgData}`
    const binary = atob(snapshotUrl.split(',')[1])
    const data = []

    for (let i = 0; i < binary.length; i += 1) {
      data.push(binary.charCodeAt(i))
    }

    const blob = new Blob([new Uint8Array(data)])
    videoServices.uploadScreenshot('interview', `opentok-archive/${archive.id}`, blob)
  }
}
